import { useMemo } from "react";

const useParsedTableData = (rawData) => {
  return useMemo(() => {
    if (!rawData) {
      return { headers: [], rows: [] };
    }

    const lines = rawData.split("\n");
    const headers = lines[0]
      .split("|")
      .slice(1, -1)
      .map((h) => h.trim());

    const rows = lines.slice(1).map((line) => {
      const cells = line
        .split("|")
        .slice(1, -1)
        .map((c) => c.trim());

      return headers.reduce((acc, header, index) => {
        acc[`col${index}`] = cells[index];
        return acc;
      }, {});
    });

    return { headers, rows };
  }, [rawData]);
};

export default useParsedTableData;
